import React, { useCallback, useEffect, useState } from "react";
import AgGridComponent from "../../../../../../components/common/AgGridComponent";
import { baseURL } from "@configs/envConfig";
import Icon from "@mdi/react";
import {
  mdiPencil,
  mdiDelete,
  mdiCog,
  mdiSetCenter,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
} from "@mdi/js";
import { Box, Button, Switch } from "@mui/material";
import CircularProgressLoading from "../../../../../../components/loaders/CircularProgressLoading";
import NewSourceOwner from "../../../../../../Models/AddNewSourceOwner";
import AddEditDestinationSource from "../../../../../../Models/addDestinationSourceDetails/AddEditDestinationSource";
import AddEditDestinationSourceConfig from "../../../../../../Models/addDestinationSourceConfig/AddEditDestinationSourceConfig";
import { useDispatch } from "react-redux";
import { snackbarMessageUpdate } from "@store/config/configSlice";
import AddDestSourceMappedHeaders from "../../../../../../Models/AddDestinationSourceMappedHeaders";
import GlobalConfirmationPopup from "../../../../../../components/common/GlobalConfirmationPopup";
import { axiosInstance } from "@services/axiosInstance";
import AddButton from "../../../../../../components/common/AddButton";
import { useSelector } from "react-redux";
import {
  useApiCallMutation,
  useGetApiCallQuery,
} from "../../../../../../services/apiQueryServices";
import {
  updateDestinationSource,
  updateTableRow,
} from "../../../../../../store/ExportDataModule/DestinationSourceSlice";

const DestinationSource = () => {
  const [rowSelected, setRowSelected] = useState({});
  const [columnDef, setColumnDef] = useState([]);
  const [openConfig, setOpenConfig] = useState(false);
  const [OpenMapHeaders, setOpenMapHeaders] = useState(false);
  const [open, setOpen] = useState(false);
  const [gridData, setGridData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isInactive, setIsInactive] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const dispatch = useDispatch();

  const TableData = useSelector((state) => state.destinationSource?.tableData);

  const { data, refetch, isError, isFetching, isLoading, isSuccess } =
    useGetApiCallQuery({
      endPoint: "dl/export/data-source/details",
      method: "POST",
      data: {
        query: {},
        options: {
          page: 1,
          limit: 10,
          pagination: false,
          options: {},
        },
      },
      headers: {},
    });

  const [apiCall1, res2] = useApiCallMutation();
  const [apiCall3, res3] = useApiCallMutation();

  useEffect(() => {
    refetch();
  }, [openConfig]);

  useEffect(() => {
    if (res2.isSuccess) {
      successCallback(res2?.data);
      dispatch(updateTableRow(res2?.data?.data));
    }
    if (res3.isSuccess) {
      successCallback(res3?.data);
      dispatch(updateTableRow(res3?.data?.data));
    }
  }, [res2, res3]);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    dispatchData();
  }, [data, isFetching, isSuccess]);

  const dispatchData = useCallback(() => {
    if (isSuccess) {
      const tableData = {
        data: [...data?.data?.data].reverse(),
        headers: data?.data?.headers,
      };
      dispatch(updateDestinationSource(tableData));
    }
  }, [isSuccess, data]);

  const successCallback = (response) => {
    const status = response?.status;
    dispatch(
      snackbarMessageUpdate({
        open: true,
        color: "success",
        message: status.value,
      })
    );
  };

  const errorCallback = (error) => {
    dispatch(
      snackbarMessageUpdate({
        open: true,
        color: "error",
        message: error.response.data.status.value,
      })
    );
  };

  const headers = {
    "Content-Type": "application/json", // Example header
    Authorization: `Bearer ${
      JSON.parse(localStorage.getItem("user"))?.token.access_token
    }`, // Example header
  };

  const handleFeedExecutionStatus = (params) => {
    return (
      <div style={{ textAlign: "center", marginTop: "0.3rem" }}>
        {params.data.feedExecutionStatus && (
          <Icon
            path={mdiCheckCircleOutline}
            size={1}
            style={{
              color: "Green",
              cursor: "pointer",
            }}
          />
        )}
        {!params.data.feedExecutionStatus && (
          <Icon
            path={mdiCloseCircleOutline}
            size={1}
            style={{
              color: "red",
              cursor: "pointer",
            }}
          />
        )}
      </div>
    );
  };

  const handleActions = (data, action) => {
    switch (action) {
      case "EDIT":
        setRowSelected(data);
        setIsEditMode(true);
        setOpen(true);
        break;
      case "ACTIVE":
        setRowSelected(data);
        if (data.isActive) {
          setIsInactive(true);
          setPopupTitle("Are you sure you want to Inactive?");
          setShowConfirmation(true);
        } else if (!data.isActive) {
          setIsActive(true);
          setPopupTitle("Are you sure you want to Active?");
          setShowConfirmation(true);
        }
        break;
      case "DELETE":
        setRowSelected(data);
        setIsDelete(true);
        setPopupTitle("Are you sure you want to Delete?");
        setShowConfirmation(true);
        break;
      case "CONFIG":
        setRowSelected(data);
        setIsEditMode(true);
        setOpenConfig(true);
        break;
      case "MAPHEADER":
        setRowSelected(data);
        setIsEditMode(true);
        setOpenMapHeaders(true);
        break;
      default: {
      }
    }
  };

  const openForm = () => {
    setOpen(true);
    setIsEditMode(false);
    setRowSelected({});
  };

  const handleConfirm = (remark) => {
    if (isActive) {
      setIsActive(false);
      const data = {
        remark: remark,
        isActive: true,
      };
      apiCall1({
        endPoint: `dl/export/data-source/active-inactive/${rowSelected?.id}`,
        method: "PUT",
        data: { data },
      });
    } else if (isInactive) {
      setIsInactive(false);
      const data = {
        remark: remark,
        isActive: false,
      };
      apiCall1({
        endPoint: `dl/export/data-source/active-inactive/${rowSelected?.id}`,
        method: "PUT",
        data: { data },
      });
    } else if (isDelete) {
      setIsDelete(false);
      const data = {
        data: {
          remark: remark,
        },
      };
      apiCall3({
        endPoint: `dl/export/data-source/delete/${rowSelected?.sourceId}`,
        method: "DELETE",
        data: { data },
        headers: { headers },
      });
    }
    setShowConfirmation(false);
  };
  const handleCancel = (data) => {
    setShowConfirmation(false);
  };

  if (isLoading) return <CircularProgressLoading />;
  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 140,
          right: 16,
        }}
      >
        <AddButton onclick={openForm}>Add New Destination Source </AddButton>
      </Box>
      {open && (
        <AddEditDestinationSource
          defaultValues={rowSelected}
          isOpen={open}
          setOpen={setOpen}
          loadData={refetch}
          isEditMode={isEditMode}
        ></AddEditDestinationSource>
      )}
      {openConfig && (
        <AddEditDestinationSourceConfig
          defaultValues={rowSelected}
          isOpen={openConfig}
          setOpen={setOpenConfig}
          loadData={refetch}
          isEditMode={isEditMode}
        />
      )}
      {OpenMapHeaders && (
        <AddDestSourceMappedHeaders
          defaultValues={rowSelected}
          isOpen={OpenMapHeaders}
          setOpen={setOpenMapHeaders}
          // loadData={loadData}
          isEditMode={isEditMode}
        />
      )}
      <GlobalConfirmationPopup
        open={showConfirmation}
        title={popupTitle}
        // message="Are you sure you want to proceed?"
        onConfirm={handleConfirm}
        onClose={handleCancel}
      />
      <AgGridComponent
        rowData={TableData?.data || []}
        columnDefs={TableData?.headers || []}
        onRowSelectionChangedHandler={(arg) => {
          setIsEditMode(true);
        }}
        actions={["EDIT", "ACTIVE", "DELETE", "CONFIG", "MAPHEADER"]}
        performAction={handleActions}
        pagination={true}
        paginationPageSize={10}
        rowMode
      />
    </>
  );
};

export default DestinationSource;
